import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { HTMLAttributes } from 'react';

type IconProps = Partial<CustomIconComponentProps> & HTMLAttributes<HTMLSpanElement>;

export const LogOutIcon = (props: Partial<CustomIconComponentProps>) => {
  const LogOutSVG = () => {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9 3.75L3 3.75L3 14.25L9 14.25V15.75H3C2.175 15.75 1.5 15.075 1.5 14.25V3.75C1.5 2.925 2.175 2.25 3 2.25H9L9 3.75ZM11.7 6.3L12.75 5.25L16.5 9L12.75 12.75L11.7 11.7L13.65 9.75H6V8.25H13.65L11.7 6.3Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={LogOutSVG} {...props} />;
};

export const KeyboardArrowDownIcon = () => {
  const KeyboardArrowDownSVG = () => {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='keyboard_arrow_down'>
          <path
            id='icon/hardware/keyboard_arrow_down_24px'
            d='M5.5575 6.22266L9 9.65766L12.4425 6.22266L13.5 7.28016L9 11.7802L4.5 7.28016L5.5575 6.22266Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={KeyboardArrowDownSVG} />;
};

export const DrawerCloseIcon = (props: IconProps) => {
  const DrawerCloseSVG = () => {
    return (
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_190_27427)'>
          <rect width='32' height='32' rx='16' fill='white' />
          <path
            d='M21.25 11.8075L20.1925 10.75L16 14.9425L11.8075 10.75L10.75 11.8075L14.9425 16L10.75 20.1925L11.8075 21.25L16 17.0575L20.1925 21.25L21.25 20.1925L17.0575 16L21.25 11.8075Z'
            fill='#696F88'
          />
        </g>
        <defs>
          <clipPath id='clip0_190_27427'>
            <rect width='32' height='32' rx='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={DrawerCloseSVG} {...props} />;
};

export const LeftArrowIcon = (props: IconProps) => {
  const LeftArrowSVG = () => {
    return (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left'>
          <path
            id='icon/hardware/keyboard_arrow_left_24px'
            d='M13.0871 13.825L9.27044 10L13.0871 6.175L11.9121 5L6.91211 10L11.9121 15L13.0871 13.825Z'
            fill='#C2C7D0'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={LeftArrowSVG} {...props} />;
};

export const RightArrowIcon = (props: IconProps) => {
  const RightArrowSVG = () => {
    return (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='keyboard_arrow_right'>
          <path
            id='icon/hardware/keyboard_arrow_right_24px'
            d='M7.41211 13.825L11.2288 10L7.41211 6.175L8.58711 5L13.5871 10L8.58711 15L7.41211 13.825Z'
            fill='#C2C7D0'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={RightArrowSVG} {...props} />;
};

export const RightArrow = (props) => {
  const RightArrowIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path d='M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z' fill='#0071CD' />
      </svg>
    );
  };
  return <Icon component={RightArrowIconSVG} {...props} />;
};

export const BottomArrow = (props) => {
  const BottomArrowIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M4.94 5.53125L8 8.58458L11.06 5.53125L12 6.47125L8 10.4712L4 6.47125L4.94 5.53125Z'
          fill='#0071CD'
        />
      </svg>
    );
  };
  return <Icon component={BottomArrowIconSVG} {...props} />;
};

export const ExpandIcon = (props: Partial<CustomIconComponentProps>) => {
  const ExpandSVG = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16'>
        <path
          fill='currentColor'
          d='M5.25 3.5h-.689L6.28 5.22a.75.75 0 0 1-1.06 1.061L3.5 4.561v.689a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 2.75 2h2.5a.75.75 0 0 1 0 1.5M3.5 11.44l1.72-1.72a.75.75 0 1 1 1.061 1.061l-1.72 1.72h.689a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 1.5 0zM13.25 10a.75.75 0 0 0-.75.75v.689l-1.72-1.72a.75.75 0 0 0-1.061 1.061l1.72 1.72h-.69a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75m-2.5-8h2.499a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-.689l-1.72 1.72a.75.75 0 0 1-1.06 0a.75.75 0 0 1 0-1.061l1.72-1.72h-.69a.75.75 0 0 1 0-1.5'
        />
      </svg>
    );
  };
  return <Icon component={ExpandSVG} {...props} />;
};

export const CollapseMenuIcon = (props: Partial<CustomIconComponentProps>) => {
  const CollapseMenuSVG = () => {
    return (
      <svg
        width='24'
        height='25'
        viewBox='0 0 24 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        data-testid='collapse-icon'
      >
        <path d='M3 6.5V8.5H16V6.5H3Z' fill='#696F88' />
        <path d='M13 13.5H3V11.5H13V13.5Z' fill='#696F88' />
        <path d='M16 18.5H3V16.5H16V18.5Z' fill='#696F88' />
        <path
          d='M17.43 12.5L21.01 16.09L19.6 17.5L14.6 12.5L19.6 7.5L21.01 8.91L17.43 12.5Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={CollapseMenuSVG} {...props} />;
};

export const ExpandMenuIcon = (props: Partial<CustomIconComponentProps>) => {
  const ExpandMenuSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        data-testid='expand-icon'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 8V6H21V8H3ZM3 13H21V11H3V13ZM3 18H21V16H3V18Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={ExpandMenuSVG} {...props} />;
};

export const SearchIcon = (props) => {
  const SearchIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2239 10.6904H11.8164L15.5589 14.4404L14.4414 15.5579L10.6914 11.8154V11.2229L10.4889 11.0129C9.63391 11.7479 8.52391 12.1904 7.31641 12.1904C4.62391 12.1904 2.44141 10.0079 2.44141 7.31543C2.44141 4.62293 4.62391 2.44043 7.31641 2.44043C10.0089 2.44043 12.1914 4.62293 12.1914 7.31543C12.1914 8.52293 11.7489 9.63293 11.0139 10.4879L11.2239 10.6904ZM3.94141 7.31543C3.94141 9.18293 5.44891 10.6904 7.31641 10.6904C9.18391 10.6904 10.6914 9.18293 10.6914 7.31543C10.6914 5.44793 9.18391 3.94043 7.31641 3.94043C5.44891 3.94043 3.94141 5.44793 3.94141 7.31543Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={SearchIconSVG} {...props} />;
};
